import { Button, Typography } from "@mui/material"
import { PostBotPageLayout } from "../components/common/postBotPageLayout"
import { Link } from "react-router-dom"
import type { TemplateWriteAccess } from "../hooks/useVersionDraft"
import { PostBotNavigation } from "../components/common/postBotNavigation"
import { PlacementsTable } from "../components/placements/placementsTable"
import { placementPath } from "../utils/placementDraft"

export default function PlacementsPage(access: TemplateWriteAccess) {
  return (
    <PostBotPageLayout>
      <PostBotNavigation />
      <Typography variant="h5">Размещения</Typography>
      {access.canWrite && !access.readOnly && (
        <Button
          component={Link}
          to={placementPath("new")}
          sx={{ alignSelf: "flex-start" }}
          variant="contained"
        >
          Создать размещение
        </Button>
      )}
      <PlacementsTable {...access} />
    </PostBotPageLayout>
  )
}
